import { useState } from 'react';
import  api  from "../utils/api";


export default function BrokerConnectAlpaca({ userId }) {
    const [apiKeyId, setApiKeyId] = useState('');
    const [apiSecret, setApiSecret] = useState('');
    const [mode, setMode] = useState('paper');
    const [status, setStatus] = useState(null);


    const save = async () => {
        try {
            const { data } = await api.post('/api/brokers/alpaca/save-keys', {
                user_id: userId,
                api_key_id: apiKeyId,
                api_secret_key: apiSecret,
                mode,
            });
            setStatus(data.ok ? 'Saved!' : 'Error');
        } catch (e) {
            setStatus('Error saving keys');
        }
    };


    const test = async () => {
        try {
            const { data } = await api.get('/api/brokers/alpaca/account', { params: { user_id: userId } });
            setStatus(`Account: ${data.account_number || data.id || 'OK'}`);
        } catch (e) { setStatus('Account check failed'); }
    };


    return (
        <div className="p-4 bg-zinc-900 rounded-2xl space-y-3">
            <h3 className="text-lg font-semibold">Connect Alpaca</h3>
            <div className="grid gap-2">
                <input className="px-3 py-2 rounded bg-zinc-800" placeholder="API Key ID" value={apiKeyId} onChange={e => setApiKeyId(e.target.value)} />
                <input className="px-3 py-2 rounded bg-zinc-800" placeholder="API Secret Key" value={apiSecret} onChange={e => setApiSecret(e.target.value)} />
                <select className="px-3 py-2 rounded bg-zinc-800" value={mode} onChange={e => setMode(e.target.value)}>
                    <option value="paper">Paper</option>
                    <option value="live">Live</option>
                </select>
            </div>
            <div className="flex gap-2">
                <button onClick={save} className="px-4 py-2 rounded bg-blue-600">Save</button>
                <button onClick={test} className="px-4 py-2 rounded bg-emerald-600">Test</button>
            </div>
            {status && <p className="text-sm text-zinc-300">{status}</p>}
        </div>
    );
}